const API_BASE =
  process.env.NODE_ENV === "production"
    ? "https://api.stylon.co/v1"
    : "http://localhost:3000/v1";

// Notify numbers that receive WhatsApp alerts for new leads (handled server-side)
const NOTIFY_NUMBERS = ["972526003409", "972502337445", "353871059483"];

export const savePotentialCustomer = async (phone) => {
  try {
    await fetch(`${API_BASE}/potential-customers`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        phone,
        source: "company_site_hero",
        notifyNumbers: NOTIFY_NUMBERS,
      }),
    });
  } catch (_) {
    // silent — never break UX for lead saving
  }
};
